export class ReadableUtils {
    static FormNameToDescriptionMap = {
        crf: `<b>Low CRF</b> value provide high quality outputs but takes <b>longer time</b> and produce <b>larger output</b> file size.
        CRF 31 is good for 1080p.
        To further compress high quality large files, use a smaller <b>Preset</b>`,
        preset: '<b>Slower Preset</b> such as medium or slow options, provide better compression but takes <b>longer time</b> for selected Contant Rate Factor.',
        scale_preset: 'Height of the video in (p) pixel. Width calculated relative to the height.',
        outputCombine: `<b>Don't Combine</b> option produces one PDF file per Image.
        <b>Combine To One PDF</b> option combines uploaded Image files in to one PDF. To <b>re-order</b>, you can drag and move above file cards.`,
        imageTransparency: `* Removing transparency allow high compression, which result in smaller PDF file size.`,

    };

    static getFormNameToDescriptionMap() {
        return ReadableUtils.FormNameToDescriptionMap;
    }
}
